import { StoreOptions } from 'vuex';
interface HaveUpload {
  showTrans: false;
  showList: false;
}
export interface TransmissionState {
  haveUpload: HaveUpload;
}

/**
 * TODO 确定是否没有用到后，要移除多余store
 */
const transmission: StoreOptions<TransmissionState> = {
  state: {
    haveUpload: {
      showTrans: false,
      showList: false,
    },
  },
  mutations: {
    SET_HAVE_UPLOAD(state: TransmissionState, params: HaveUpload): void {
      state.haveUpload = params;
    },
  },
};
export default transmission;
